import { Component, inject, OnInit } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { AuthService } from '../providers/auth.service';
import { SidebarService } from '../providers/sidebar.service';
import { CommonModule } from '@angular/common';
import { DbService } from '../providers/db.service';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CategoryInterface, PeriodsInterface } from '../interfaces';

@Component({
  selector: 'app-budget',
  standalone: true,
  imports: [TranslocoDirective, CommonModule, FormsModule],
  templateUrl: './budget.component.html',
  styleUrl: './budget.component.css'
})
export class BudgetComponent implements OnInit {
  showSpinner = true;
  loadingTotal = false;
  allCategories = false;
  catsArray: CategoryInterface[] = [];
  periodsArray: PeriodsInterface[] = [];
  periodsShortArray: number[] = [];
  fromPeriodsArray: number[] = [];
  sideBarSize = '';
  selectedCategory = -1;
  maxNumberOfCategories = 8;
  period: number = 0;
  periodToCloneFrom = 0;
  periodTranslocoTemp = '';
  periodTransloco = '';
  totalBudget = 0;
  periodModel = '0';
  budgetModel = {
    name: 'test',
    value: undefined
  };

  public db = inject(DbService);
  public auth = inject(AuthService);
  private translocoService = inject(TranslocoService);
  private toastr = inject(ToastrService);
  public sb = inject(SidebarService);



  ngOnInit(): void {
    this.ngOnInitAsync()
  }

  async ngOnInitAsync(): Promise<void> {
    try {
      const now = new Date();
      this.period = this.getYyyymm(now);
      this.periodToCloneFrom = this.getYyyymm(new Date(now.getFullYear(), now.getMonth() - 1, 1));
      this.periodTranslocoTemp = 'calendar.'.concat(this.period.toString());
      await this.listOfCatsAndBudgets();
      await this.listOfPeriods();
      this.periodTransloco = this.translocoService.translate(this.periodTranslocoTemp, undefined, this.auth.currentUserSig()?.lang);
      this.sideBarSize = this.sb.currentSidebarSize();
      this.showSpinner = false;
    } catch (err) {
      console.log(err.code)
    }
  }
  async listOfCatsAndBudgets(): Promise<void> {
    try {
      this.catsArray = await this.db.getCatsAsync(this.auth.currentUserIDSig().uid);
      this.totalBudget = 0;
    } catch (err) {
      console.error('Error while fetching categories:', err);
    }
  }

  async listOfPeriods(): Promise<void> {
    try {
      this.periodsShortArray = []
      this.periodsArray = await this.db.getPeriodsAsync(this.auth.currentUserIDSig().uid);
      for (const period of this.periodsArray) {
        this.periodsShortArray.push(period.content['periodID']);
        if (period.content['periodID'] === this.period) {
          this.totalBudget = period.content['budget']
        }
      }
      this.periodsShortArray.sort()
      this.periodsShortArray.reverse()
      const filteredArray = this.periodsShortArray.filter(elem => elem !== this.period)
      this.fromPeriodsArray = filteredArray;
    } catch (err) {
      console.log('Error fetching periods:', err)
    }
  }

  async updateMonthlyBudget(model: { value: number; }, catID: string, period: number): Promise<void> {
    this.loadingTotal = true;
    const newBudget = model.value;
    const deltaBudget = newBudget - this.catsArray[this.selectedCategory].content[period].budget;
    try {
      // await this.db.updateBudgetInCategoriesAsync(period, model.value, catID, this.auth.currentUserIDSig().uid);
      // await this.db.updateBudgetInPeriodsAsync(period, deltaBudget, this.auth.currentUserIDSig().uid);
      await this.db.updateBudget(period, catID, newBudget, deltaBudget, this.auth.currentUserIDSig().uid);
      await this.listOfCatsAndBudgets();
      await this.listOfPeriods();
      this.showToast('success', `${this.translocoService.translate('toasts.budgetSuccessMessage', undefined, this.auth.currentUserSig()?.lang)}`)
      this.budgetModel.value = 0;
      this.loadingTotal = false;
    } catch (err) {
      console.log(err.code)
      this.showToast('error', `${this.translocoService.translate('toasts.budgetFailMessage', undefined, this.auth.currentUserSig()?.lang)}`)
      this.budgetModel.value = 0;
      this.loadingTotal = false;
    }
  }

  async cloneBudget(fromPeriod: number, toPeriod: number): Promise<void> {
    this.loadingTotal = true;
    this.allCategories = true;

    try {
      const fromPeriodBudget = this.periodsArray.find(x => x.content['periodID'] === fromPeriod)?.content['budget'];
      await this.db.cloneBudgetAsync(fromPeriod, toPeriod, fromPeriodBudget, this.auth.currentUserIDSig().uid);
      await this.listOfCatsAndBudgets()
      await this.listOfPeriods()
      this.showToast('success', `${this.translocoService.translate('toasts.budgetSuccessMessage', undefined, this.auth.currentUserSig()?.lang)}`)
      this.loadingTotal = false;
      this.allCategories = false;
    } catch (err) {
      console.log(err.code)
      this.showToast('error', `${this.translocoService.translate('toasts.budgetFailMessage', undefined, this.auth.currentUserSig()?.lang)}`)
      this.loadingTotal = false;
      this.allCategories = false;
    }
  }

  setPeriod(newPeriod: number): void {

    this.period = newPeriod;
    for (const period of this.periodsArray) {
      if (period.content['periodID'] === newPeriod) {
        this.totalBudget = period.content['budget']
      }
    }
    this.fromPeriodsArray = this.periodsShortArray
    this.fromPeriodsArray.filter(period => period !== newPeriod)
  }

  setPeriodToCloneFrom(newPeriod: number) {
    this.periodToCloneFrom = newPeriod;
  }

  showToast(toastType: string, title: string, content?: string) {
    const varTimeOut = 4000;
    const varProgressBar = true;
    const varPositionClass = 'toast-top-center';
    if (toastType === 'success') {
      this.toastr.success(content, title, {
        timeOut: varTimeOut,
        progressBar: varProgressBar,
        positionClass: varPositionClass
      });
    } else if (toastType === 'info') {
      this.toastr.info(content, title, {
        timeOut: varTimeOut,
        progressBar: varProgressBar,
        positionClass: varPositionClass
      });
    } else {
      this.toastr.error(content, title, {
        timeOut: varTimeOut,
        progressBar: varProgressBar,
        positionClass: varPositionClass
      });
    }
  }

  getYyyymm(date: Date): number {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    return parseInt(`${year}${month.toString().padStart(2, '0')}`);
  }
}

